import { queryOptions } from '@tanstack/react-query';
import { axiosGet } from '../utils/api';

export const ADMIN_KNOWLEDGE_BASE_KEY = ['/admin/knowledge-base'];

export const getAdminKnowledgeBase = ({ clientId, accessToken } = {}) =>
  queryOptions({
    queryKey: [...ADMIN_KNOWLEDGE_BASE_KEY, clientId],
    enabled: Boolean(clientId),
    queryFn: async () => {
      const res = await axiosGet('/admin/knowledge-base', { params: { clientId } }, accessToken);
      return res.data;
    },
  });
